export default [
    {
        id: "yhgl",
        name: "cookie用户",
        url: "/user/manage",
        children: [
            {
                id: "yhgl_yhlb",
                name: "用户列表",
                url: "/user/list",
                children: [
                    {
                        id: "yhgl_yhlb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "yhgl_yhlb_ckxq",
                        name: "查看详情",
                    },
                ],
            },
        ],
    },
    {
        id: "hygl",
        name: "会员管理",
        url: "/member/manage",
        children: [
            {
                id: "hygl_hylb",
                name: "会员列表",
                url: "/member/list",
                children: [
                    {
                        id: "hygl_hylb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "hygl_hylb_xz",
                        name: "新增",
                    },
                    {
                        id: "hygl_hylb_ck",
                        name: "查看",
                    },
                    {
                        id: "hygl_hylb_bj",
                        name: "编辑",
                    },
                    {
                        id: "hygl_hylb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "hygl_bqgl",
                name: "标签管理",
                url: "/member/tag",
                children: [
                    {
                        id: "hygl_bqgl_xz",
                        name: "新增",
                    },
                    {
                        id: "hygl_bqgl_ckglyh",
                        name: "查看关联用户",
                    },
                    {
                        id: "hygl_bqgl_bj",
                        name: "编辑",
                    },
                    {
                        id: "hygl_bqgl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "dlgl",
        name: "代理管理",
        url: "/proxy/manage",
        children: [
            {
                id: "dlgl_dlylb",
                name: "代理员列表",
                url: "/proxy/list",
                children: [
                    {
                        id: "dlgl_dlylb_djpz",
                        name: "等级配置",
                    },
                    {
                        id: "dlgl_dlylb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "dlgl_dlylb_szdly",
                        name: "设置代理员",
                    },
                    {
                        id: "dlgl_dlylb_xz",
                        name: "新增",
                    },
                    {
                        id: "dlgl_dlylb_ck",
                        name: "查看",
                    },
                    {
                        id: "dlgl_dlylb_bj",
                        name: "编辑",
                    },
                    {
                        id: "dlgl_dlylb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "dlgl_djpz",
                name: "等级配置",
                url: "/proxy/level",
                children: [
                    {
                        id: "dlgl_djpz_xz",
                        name: "新增",
                    },
                    {
                        id: "dlgl_djpz_bj",
                        name: "编辑",
                    },
                    {
                        id: "dlgl_djpz_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "tggl",
        name: "推广管理",
        url: "/promotion/manage",
        children: [
            {
                id: "tggl_tglb",
                name: "推广列表",
                url: "/promotion/list",
                children: [
                    {
                        id: "tggl_tglb_dc",
                        name: "导出",
                    },
                ],
            },
        ],
    },
    {
        id: "cpgl",
        name: "产品管理",
        url: "/product/manage",
        children: [
            {
                id: "cpgl_cplb",
                name: "产品列表",
                url: "/product/list",
                children: [
                    {
                        id: "cpgl_cplb_mbxz",
                        name: "模板下载",
                    },
                    {
                        id: "cpgl_cplb_pldr",
                        name: "批量导入",
                    },
                    {
                        id: "cpgl_cplb_cpsy",
                        name: "产品水印",
                    },
                    {
                        id: "cpgl_cplb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "cpgl_cplb_xz",
                        name: "新增",
                    },
                    {
                        id: "cpgl_cplb_ts",
                        name: "停售",
                    },
                    {
                        id: "cpgl_cplb_bj",
                        name: "编辑",
                    },
                    {
                        id: "cpgl_cplb_xj",
                        name: "下架",
                    },
                    {
                        id: "cpgl_cplb_sj",
                        name: "上架",
                    },
                    {
                        id: "cpgl_cplb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "cpgl_plsh",
                name: "评论审核",
                url: "/product/commentAudit",
                children: [
                    {
                        id: "cpgl_plsh_tg",
                        name: "通过",
                    },
                    {
                        id: "cpgl_plsh_jj",
                        name: "拒绝",
                    },
                ],
            },
            {
                id: "cpgl_pllb",
                name: "评论列表",
                url: "/product/comment",
                children: [
                    {
                        id: "cpgl_pllb_dc",
                        name: "导出",
                    },
                    {
                        id: "cpgl_pllb_zd",
                        name: "置顶",
                    },
                    {
                        id: "cpgl_pllb_qxzd",
                        name: "取消置顶",
                    },
                    {
                        id: "cpgl_pllb_yc",
                        name: "下架",
                    },
                    {
                        id: "cpgl_pllb_xs",
                        name: "上架",
                    },
                    {
                        id: "cpgl_pllb_ck",
                        name: "查看",
                    },
                    {
                        id: "cpgl_pllb_hf",
                        name: "回复",
                    },
                    {
                        id: "cpgl_pllb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "cpgl_cpfl",
                name: "产品分类",
                url: "/product/category",
                children: [
                    {
                        id: "cpgl_cpfl_tjyjfl",
                        name: "添加一级分类",
                    },
                    {
                        id: "cpgl_cpfl_tjxjfl",
                        name: "添加下级分类",
                    },
                    {
                        id: "cpgl_cpfl_bj",
                        name: "编辑",
                    },
                    {
                        id: "cpgl_cpfl_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "cpgl_cpsy",
                name: "产品水印",
                url: "/product/watermark",
                children: [
                    {
                        id: "cpgl_cpsy_plgx",
                        name: "批量更新",
                    },
                    {
                        id: "cpgl_cpsy_th",
                        name: "替换",
                    },
                ],
            },
            {
                id: "cpgl_tjlb",
                name: "推荐列表",
                url: "/product/recommend",
                children: [
                    {
                        id: "cpgl_tjlb_xz",
                        name: "新增",
                    },
                    {
                        id: "cpgl_tjlb_sy",
                        name: "上移",
                    },
                    {
                        id: "cpgl_tjlb_xy",
                        name: "下移",
                    },
                    {
                        id: "cpgl_tjlb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "cpgl_mgclb",
                name: "敏感词列表",
                url: "/product/word",
                children: [
                    {
                        id: "cpgl_mgclb_xzmb",
                        name: "下载模板",
                    },
                    {
                        id: "cpgl_mgclb_dr",
                        name: "导入",
                    },
                    {
                        id: "cpgl_mgclb_dc",
                        name: "导出",
                    },
                    {
                        id: "cpgl_mgclb_xz",
                        name: "新增",
                    },
                    {
                        id: "cpgl_mgclb_jy",
                        name: "禁用",
                    },
                    {
                        id: "cpgl_mgclb_qy",
                        name: "启用",
                    },
                    {
                        id: "cpgl_mgclb_bj",
                        name: "编辑",
                    },
                    {
                        id: "cpgl_mgclb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "cpgl_sxqgl",
                name: "筛选器管理",
                url: "/product/filter",
                children: [
                    {
                        id: "cpgl_sxqgl_xz",
                        name: "新增",
                    },
                    {
                        id: "cpgl_sxqgl_ck",
                        name: "查看",
                    },
                    {
                        id: "cpgl_sxqgl_bj",
                        name: "编辑",
                    },
                    {
                        id: "cpgl_sxqgl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "fagl",
        name: "方案管理",
        url: "/plan/manage",
        children: [
            {
                id: "fagl_falb",
                name: "方案列表",
                url: "/plan/list",
                children: [
                    {
                        id: "fagl_falb_fafl",
                        name: "方案分类",
                    },
                    {
                        id: "fagl_falb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "fagl_falb_xz",
                        name: "新增",
                    },
                    {
                        id: "fagl_falb_ck",
                        name: "查看",
                    },
                    {
                        id: "fagl_falb_bj",
                        name: "编辑",
                    },
                    {
                        id: "fagl_falb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "fagl_fafl",
                name: "方案分类",
                url: "/plan/category",
                children: [
                    {
                        id: "fagl_fafl_xz",
                        name: "新增",
                    },
                    {
                        id: "fagl_fafl_bj",
                        name: "编辑",
                    },
                    {
                        id: "fagl_fafl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "yhqgl",
        name: "优惠券管理",
        url: "/coupon/manage",
        children: [
            {
                id: "yhqgl_yhqlb",
                name: "优惠券列表",
                url: "/coupon/list",
                children: [
                    {
                        id: "yhqgl_yhqlb_pldc",
                        name: "批量导出",
                    },
                    {
                        id: "yhqgl_yhqlb_xz",
                        name: "新增",
                    },
                    {
                        id: "yhqgl_yhqlb_lqxq",
                        name: "领取详情",
                    },
                    {
                        id: "yhqgl_yhqlb_bj",
                        name: "编辑",
                    },
                    {
                        id: "yhqgl_yhqlb_sc",
                        name: "删除",
                    },
                    {
                        id: "yhqgl_yhqlb_sj",
                        name: "数据",
                    },
                ],
            },
        ],
    },
    {
        id: "algl",
        name: "案例管理",
        url: "/case/manage",
        children: [
            {
                id: "algl_allb",
                name: "案例列表",
                url: "/case/list",
                children: [
                    {
                        id: "algl_allb_alfl",
                        name: "案例分类",
                    },
                    {
                        id: "algl_allb_xz",
                        name: "新增",
                    },
                    {
                        id: "algl_allb_ckxq",
                        name: "查看详情",
                    },
                    {
                        id: "algl_allb_bj",
                        name: "编辑",
                    },
                    {
                        id: "algl_allb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "algl_alfl",
                name: "案例分类",
                url: "/case/category",
                children: [
                    {
                        id: "algl_alfl_xz",
                        name: "新增",
                    },
                    {
                        id: "algl_alfl_bj",
                        name: "编辑",
                    },
                    {
                        id: "algl_alfl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "spgl",
        name: "视频管理",
        url: "/video/manage",
        children: [
            {
                id: "spgl_splb",
                name: "视频列表",
                url: "/video/list",
                children: [
                    {
                        id: "spgl_splb_spfl",
                        name: "视频分类",
                    },
                    {
                        id: "spgl_splb_xz",
                        name: "新增",
                    },
                    {
                        id: "spgl_splb_ckxq",
                        name: "查看详情",
                    },
                    {
                        id: "spgl_splb_bj",
                        name: "编辑",
                    },
                    {
                        id: "spgl_splb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "spgl_spfl",
                name: "视频分类",
                url: "/video/category",
                children: [
                    {
                        id: "spgl_spfl_xz",
                        name: "新增",
                    },
                    {
                        id: "spgl_spfl_tjxjfl",
                        name: "添加下级分类",
                    },
                    {
                        id: "spgl_spfl_bj",
                        name: "编辑",
                    },
                    {
                        id: "spgl_spfl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "wjgl",
        name: "文件管理",
        url: "/file/manage",
        children: [
            {
                id: "wjgl_wjlb",
                name: "文件列表",
                url: "/file/list",
                children: [
                    {
                        id: "wjgl_wjlb_wjfl",
                        name: "文件分类",
                    },
                    {
                        id: "wjgl_wjlb_xz",
                        name: "新增",
                    },
                    {
                        id: "wjgl_wjlb_ckxq",
                        name: "查看详情",
                    },
                    {
                        id: "wjgl_wjlb_bj",
                        name: "编辑",
                    },
                    {
                        id: "wjgl_wjlb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "wjgl_wjfl",
                name: "文件分类",
                url: "/file/category",
                children: [
                    {
                        id: "wjgl_wjfl_xz",
                        name: "新增",
                    },
                    {
                        id: "wjgl_wjfl_bj",
                        name: "编辑",
                    },
                    {
                        id: "wjgl_wjfl_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "nrgl",
        name: "内容管理",
        url: "/content/manage",
        children: [
            {
                id: "nrgl_banner",
                name: "banner管理",
                url: "/content/banner",
                children: [
                    {
                        id: "nrgl_banner_xz",
                        name: "新增",
                    },
                    {
                        id: "nrgl_banner_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_banner_sj",
                        name: "上架",
                    },
                    {
                        id: "nrgl_banner_xj",
                        name: "下架",
                    },
                    {
                        id: "nrgl_banner_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_link",
                name: "友情链接管理",
                url: "/content/link",
                children: [
                    {
                        id: "nrgl_link_xz",
                        name: "新增",
                    },
                    {
                        id: "nrgl_link_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_link_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_about",
                name: "关于我们",
                url: "/content/about",
            },
            {
                id: "nrgl_contact",
                name: "联系方式",
                url: "/content/contact",
                children: [
                    {
                        id: "nrgl_contact_gx",
                        name: "更新",
                    },
                    {
                        id: "nrgl_contact_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_channel",
                name: "购买渠道",
                url: "/content/channel",
            },
            {
                id: "nrgl_story",
                name: "杰锐德故事",
                url: "/content/story",
                children: [
                    {
                        id: "nrgl_story_xz",
                        name: "新增",
                    },
                    {
                        id: "nrgl_story_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_story_sj",
                        name: "上架",
                    },
                    {
                        id: "nrgl_story_xj",
                        name: "下架",
                    },
                    {
                        id: "nrgl_story_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_home",
                name: "首页中部资源位",
                url: "/content/home",
            },
            {
                id: "nrgl_mine",
                name: "个人中心资源位",
                url: "/content/mine",
            },
            {
                id: "nrgl_follow",
                name: "关注我们",
                url: "/content/follow",
                children: [
                    {
                        id: "nrgl_follow_xz",
                        name: "新增",
                    },
                    {
                        id: "nrgl_follow_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_follow_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_subscribe",
                name: "订阅我们",
                url: "/content/subscribe",
            },
            {
                id: "nrgl_hot",
                name: "热搜词管理",
                url: "/content/hot",
                children: [
                    {
                        id: "nrgl_hot_xz",
                        name: "新增",
                    },
                    {
                        id: "nrgl_hot_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_hot_sj",
                        name: "上架",
                    },
                    {
                        id: "nrgl_hot_xj",
                        name: "下架",
                    },
                    {
                        id: "nrgl_hot_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_footer",
                name: "底部导航栏",
                url: "/content/footer",
                children: [
                    {
                        id: "nrgl_footer_xzlm",
                        name: "新增栏目",
                    },
                    {
                        id: "nrgl_footer_bj",
                        name: "编辑",
                    },
                    {
                        id: "nrgl_footer_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "nrgl_privacy",
                name: "隐私政策",
                url: "/content/privacy",
            },
            {
                id: "nrgl_use",
                name: "使用政策",
                url: "/content/use",
            },
            {
                id: "nrgl_cookie",
                name: "cookie政策",
                url: "/content/cookie",
            },
        ],
    },
    {
        id: "sjgl",
        name: "数据管理",
        url: "/data/manage",
        children: [
            {
                id: "sjgl_sjfx",
                name: "数据分析",
                url: "/data/stat",
                children: [
                    {
                        id: "sjgl_sjfx_dcsj",
                        name: "导出数据",
                    },
                ],
            },
        ],
    },
    {
        id: "xxtz",
        name: "消息通知",
        url: "/msg/manage",
        children: [
            {
                id: "xxtz_xxlb",
                name: "消息列表",
                url: "/msg/list",
                children: [
                    {
                        id: "xxtz_xxlb_xz",
                        name: "新增",
                    },
                    {
                        id: "xxtz_xxlb_ck",
                        name: "查看",
                    },
                    {
                        id: "xxtz_xxlb_sc",
                        name: "删除",
                    },
                ],
            },
        ],
    },
    {
        id: "qxgl",
        name: "权限管理",
        url: "/auth/manage",
        children: [
            {
                id: "qxgl_jslb",
                name: "角色列表",
                url: "/auth/role",
                children: [
                    {
                        id: "qxgl_jslb_xz",
                        name: "新增",
                    },
                    {
                        id: "qxgl_jslb_bj",
                        name: "编辑",
                    },
                    {
                        id: "qxgl_jslb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "qxgl_glylb",
                name: "管理员列表",
                url: "/auth/user",
                children: [
                    {
                        id: "qxgl_glylb_xz",
                        name: "新增",
                    },
                    {
                        id: "qxgl_glylb_bj",
                        name: "编辑",
                    },
                    {
                        id: "qxgl_glylb_sc",
                        name: "删除",
                    },
                ],
            },
            {
                id: "qxgl_czrz",
                name: "操作日志",
                url: "/auth/log",
            },
        ],
    },
];
